export const ORDER_X_PAGE_ROUTE = '[A-Za-z0-9-]+';
